import ViewHtml from './../viewHtml';
export default {
  name: "index",
  props: {
    placement: {
      type: String,
      default: function _default() {
        return 'top-start';
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return 'hover';
      }
    },
    width: {
      type: String,
      default: function _default() {
        return '200';
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '预览';
      }
    },
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  components: {
    ViewHtml: ViewHtml
  }
};